

export type IEventHistory = {
  timestamp: number;
  updatedAt?: number;
  createdAt: number;
  id: string;
  tenantId: string;
  crateId: string;
  userId: string;
  type: EventType;
  x: number;
  y: number;
  z: number;
  deviceName: string;
  groundPositionAlias: string;
  groundPositionGroupLevelName: string;
  taskType: TaskType;
  user: {
    firstName: string;
    lastName: string;
  };
  previousSkuGroups: SkuGroups[];
  currentSkuGroups: SkuGroups[];
  skuGroupsTransferredIn?: SkuGroups[];
  skuGroupsTransferredOut?: SkuGroups[];
  originCrate?: { tagRfid: string, groundPositionAlias: string, groundPositionGroupLevelName: string };
  destinationCrate?: { tagRfid: string, groundPositionAlias: string, groundPositionGroupLevelName: string };
}

export type EditedUnloadEventHistoryItem = IEventHistory & {
  forkliftPosition: {
    groundPositionAlias: string;
    groundPositionGroupLevelName: string;
    x: number;
    y: number;
    z: number;
  }
}

export type DispatchEventHistoryType =
  | EventType.START_WITH_OUT_ORDER
  | EventType.START_WITHOUT_OUT_ORDER
  | EventType.FINISH
  | EventType.CANCEL;

export interface DispatchEventHistoryUser {
  id: string;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  type: string;
  currentDevice: string;
  tenantId: string;
  logConfig: string;
  createdAt: number;
  updatedAt: number;
  lastSeenAt: number;
  online: boolean;
}

export enum CrateListPalletState {
  OK = 'OK',
  MISSING = 'MISSING',
}

export interface CrateListSkuGroup {
  sku: string;
  name: string;
  packSize: number;
  quantity: number;
}

export interface CrateListPallet {
  crateId: string;
  tagRfid: string;
  state: CrateListPalletState;
  skuGroups: CrateListSkuGroup[];
}

export interface CrateList {
  pallets: CrateListPallet[];
}

export interface IDispatchEventHistory {
  id: string;
  tenantId: string;
  outOrderId: string;
  outOrderNo?: string;
  userId: string;
  timestamp: number;
  type: DispatchEventHistoryType;
  taskType: TaskType.DISPATCH;
  deviceName: string | null;
  crateList: CrateList | null;
  crateListVersion: number;
  createdAt: number;
  updatedAt: number;
  user: DispatchEventHistoryUser;
}

export interface IFinishedOutOrderHistory extends IDispatchEventHistory {
  outOrderNo: string;
  checkedPallets?: CrateListPallet[];
  missingPallets?: CrateListPallet[];
}

export type ISellOrderEventHistory = IFinishedOutOrderHistory;

export interface SkuGroups {
  crateId?: string;
  sku: string;
  packSize: number;
  quantity: number;
  createdAt?: number;
  updatedAt?: number;
  name: string;
  description?: string;
  productName?: string;
}

export enum EventType {
  FOUND = "FOUND",
	FOUND_MISPLACED = "FOUND_MISPLACED",
	MISSING = "MISSING",
	LOAD = "LOAD",
	UNLOAD = "UNLOAD",
	EXIT = "EXIT",
	ENTRY = "ENTRY",
	EDIT_PRODUCT = "EDIT_PRODUCT",
  UNLOAD_NOT_CONFIRMED = "UNLOAD_NOT_CONFIRMED",
  EDITED_UNLOAD = "EDITED_UNLOAD",
  SET_UNDER_ALERT = "SET_UNDER_ALERT",
  UNSET_UNDER_ALERT = "UNSET_UNDER_ALERT",
  LINKED_OUT_ORDER = "LINKED_OUT_ORDER",
  UNLINKED_OUT_ORDER = "UNLINKED_OUT_ORDER",
  TRANSFER_IN = 'TRANSFER_IN',
  TRANSFER_OUT = 'TRANSFER_OUT',
  FINISH = 'FINISH',
  START_WITH_OUT_ORDER = 'START_WITH_OUT_ORDER',
  START_WITHOUT_OUT_ORDER = 'START_WITHOUT_OUT_ORDER',
  CANCEL = 'CANCEL',
}

export enum TaskType {
  RECEIVING = "RECEIVING",
  RECEIVE = 'RECEIVE',
  DISPATCHING = "DISPATCHING",
  DISPATCH = "DISPATCH",
  LOAD_DISPATCH = "LOAD_DISPATCH",
  RELOCATE_STORAGE = "RELOCATE_STORAGE",
  RELOCATE_POSITION = "RELOCATE_POSITION",
  RELOCATE_EXPEDITION = "RELOCATE_EXPEDITION",
  RELOCATE_DIVERGENT = "RELOCATE_DIVERGENT",
  RELOCATE_QUALITY = "RELOCATE_QUALITY",
  RELOCATE_DOCK = "RELOCATE_DOCK",
  RELOCATE_FREE = "RELOCATE_FREE",
  RELOCATE_FROM_PICKING = "RELOCATE_FROM_PICKING",
  RELOCATE_BY_HANDSCANNER = "RELOCATE_BY_HANDSCANNER",
  INVENTORY_BY_GROUND_POSITION_GROUP = "INVENTORY_BY_GROUND_POSITION_GROUP",
  INVENTORY_BY_PRODUCT = "INVENTORY_BY_PRODUCT",
  INVENTORY_BY_TAG_RFID = "INVENTORY_BY_TAG_RFID",
  INVENTORY_BY_GROUND_POSITION = "INVENTORY_BY_GROUND_POSITION",
  PRODUCT_INVENTORY_BY_CRATE_TAG_RFID = "PRODUCT_INVENTORY_BY_CRATE_TAG_RFID",
  INVENTORY_BY_MISSING_CRATE = "INVENTORY_BY_MISSING_CRATE",
  PRODUCT_PICKING = "PRODUCT_PICKING",
  PICKING = "PICKING",
  EDIT_PALLET = "EDIT_PALLET",
  EXIT_BY_GROUND_POSITION = "EXIT_BY_GROUND_POSITION",
  EXIT_MISSING_PALLETS = "EXIT_MISSING_PALLETS",
  RECEIVE_WITH_IN_ORDER = 'RECEIVE_WITH_IN_ORDER',
  CREATE_CRATE = "CREATE_CRATE",
  TAKE_SOME_PRODUCTS_TO_EXIT = "TAKE_SOME_PRODUCTS_TO_EXIT",
  PALLET_MANAGEMENT = "PALLET_MANAGEMENT",
  PACKING = "PACKING",
  PALLET_TRANSFER = "PALLET_TRANSFER",
  INVENTORY_BY_PIGEONHOLE_POSITION = "INVENTORY_BY_PIGEONHOLE_POSITION",
}
